import { useCallback, useContext, useMemo } from 'react';
import { UserSessionContext } from 'components/UserSession';

const useLogout = () => {
  const { setUserSession } = useContext(UserSessionContext);

  const onLogoutClick = useCallback(async () => {
    setUserSession({});
  }, [setUserSession]);

  return useMemo(() => ({
    onLogoutClick,
  }), [onLogoutClick]);
};

export default useLogout;
